<button mat-flat-button color="primary" (click)="exportData()" [disabled]="!hasData">{{ label }}</button>
